/* @flow */

export type $SearchResultsViewMode = {
  key: string,
  label: string
};

export const SearchResultsViewMode = {
  LIST_MODE: {
    key: 'LIST_MODE',
    label: 'List mode'
  },
  MAP_MODE: {
    key: 'MAP_MODE',
    label: 'Map mode'
  },
  COMBO_MODE_LIST: {
    key: 'COMBO_MODE_LIST',
    label: 'Combo mode (list activated)'
  },
  COMBO_MODE_MAP: {
    key: 'COMBO_MODE_MAP',
    label: 'Combo mode (map activated)'
  }
};

export default SearchResultsViewMode;

export const SearchResultsViewModeTracking = {
  LIST: 'list',
  MAP: 'map'
};
